import finalizingLogo from "@/assets/finalizing-logo.png";
import formattingLogo from "@/assets/formatting-logo.png";
import chartsLogo from "@/assets/charts-logo.png";
import modelingLogo from "@/assets/modeling-logo.png";
import dataLogo from "@/assets/data-logo.png";
import utilitiesLogo from "@/assets/utilities-logo.png";
import connectionsLogo from "@/assets/connections-logo.png";
import workflowAutomationLogo from "@/assets/workflow-automation-logo.png";

const CATEGORY_IMAGES: Record<string, string> = {
  "Finalizing": finalizingLogo,
  "Formatting": formattingLogo,
  "Charts": chartsLogo,
  "Modeling": modelingLogo,
  "Data": dataLogo,
  "Utilities": utilitiesLogo,
  "Connections": connectionsLogo,
  "Workflow Automation": workflowAutomationLogo,
  // Legacy support
  "Cleanup": finalizingLogo,
  "Data Cleanup": finalizingLogo,
};

export const getCategoryImage = (categoryName?: string | null): string | null => {
  if (!categoryName) return null;
  return CATEGORY_IMAGES[categoryName] || null;
};
